import { render } from "./ForgotOptions.vue?vue&type=template&id=c510c572&scoped=true"
import script from "./ForgotOptions.vue?vue&type=script&lang=js"
export * from "./ForgotOptions.vue?vue&type=script&lang=js"

import "./ForgotOptions.vue?vue&type=style&index=0&id=c510c572&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c510c572"

export default script